// 必须在所有其他导入之前执行 polyfill
import './utils/polyfill.ts'

import { createRoot } from 'react-dom/client'
import './index.scss'
import App from './App.tsx'
import '@/service/arms.ts'

console.log('MOYU')
createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <App />
  // </StrictMode>
)
